import PermissionRestService from '../rest/PermissionRestService'

class PermissionService {
  get() {
    return PermissionRestService.get()
  }
}

export default new PermissionService() as PermissionService
